/**
 * 서류/줌 업로드
 */
export default class Upload {
    constructor() {
    }

    /**
     * 누가 업로드를 호출했는지
     * 업로드 완료 이벤트가 여기저기 걸려있을수 있는데, 업로드 호출한쪽에서만 업로드 처리를 해야할것이다. 이함수를 통하여 그것을 판단한다.
     * @returns {*}
     */
    getContext(){
        return this.options.context;
    }

    /**
     * addPhotoHere 를 거치지 않고 앱 브릿지로 직접 업로드를 태우는 경로
     * (예: 디바이스 사진 그리드 피커의 uploadSelectedPhotos) 에서 context 만 선점한다.
     * 완료 이벤트는 동일하게 'upload:image' 로 오므로, 수신자가 getContext() 로 자기 것을 가려낼 수 있다.
     */
    setContext(options = {}){
        this.options = options;
    }

    /**
     * 업로드후에 input 값 초기화
     */
    resetFile(){
        // fileUploadTmpform 값을 초기화
        $('#fileUploadTmpform').val('');
    }

    /**
     * 이미지 업로드 클릭
     * @param {object}  options
     * @param {boolean} [options.original] true면 앱이 리사이즈를 건너뛰고 원본 해상도로 올린다
     *   (AppBridge.js startUploadImage 참고) — OCR처럼 화질이 결과에 직결되는 곳만 켠다.
     * @param {string} [options.guide] 'card'면 촬영(from:'C')을 앱 안 카드 스캔 화면으로 띄운다
     *   (AppBridge.js startUploadImage 참고).
     * @param {boolean} [options.pdf] true면 앱이 2장 이상 고른 사진을 PDF 한 파일로 묶어 한 번만 올린다 —
     *   'upload:image' 는 파일 하나(type 'F', pages 쪽수). 1장이면 사진 그대로(type 'I') 온다 — 수신부는 type 으로 가른다.
     *   $j.F.App.pdfUploadSupported() 인 앱만 켠다(구앱은 낱장으로 올라온다).
     *   PC 경로엔 적용되지 않는다(이미지 그대로 — multiple/batch 로 받는다).
     * @param {number} [options.pdfMaxBytes] 묶은 PDF 크기 한도(바이트). 넘으면 앱이 화질을 낮춰 다시 묶고, 끝까지 넘으면
     *   올리지 않고 회원에게 안내한 뒤 {result:false, message} 가 온다. 첨부 한도가 있는 화면(카드 가맹서류 5.5MB)이 넘긴다.
     */
    addPhotoHere(options = {}) {
        const self = this;
        options.max_sheet = options.max_sheet ?? 1;
        options.multiple  = !!options.multiple;   // PC 파일창에서 여러 장 고르기
        options.batch     = !!options.batch;      // 여러 장을 다 올린 뒤 'upload:image' 를 배열로 한 번만 (앱 여러 장 콜백과 같은 꼴)
        this.options = options;
        if ($('#fupForm').length === 0) {
            const html = `
<form id="fupForm" name="fupForm" method="post" enctype="multipart/form-data">
    <input type="file" name="file" id="fileUploadTmpform" accept="image/*" style="display:none">
</form>`;
            $('body').append(html);

            $('#fileUploadTmpform').on('change', function(){
                const files = Array.from(this.files || []);
                if (!files.length) return;

                const pdf = self.options.from === 'F';
                if (files.some(f => pdf ? f.type !== 'application/pdf' : !f.type.startsWith('image/'))) {
                    $j.Common.Util.tsalert('warning', pdf ? 'PDF 파일만 업로드 가능합니다.' : '이미지 파일만 업로드 가능합니다.');
                    this.value = ''; // 선택 초기화
                    return;
                }
                // 여러 장은 차례로 (uploadStart 는 form 하나를 통째로 보내 한 장만 간다)
                if (self.options.multiple && files.length > 1) {
                    if (self.options.batch) self.uploadBatch(files); else self.uploadFiles(files);
                    this.value = '';
                }
                else self.uploadStart();
            });
        }

        // 입력은 한 벌을 돌려 쓴다 — 부르는 쪽마다 다르므로 열 때 다시 맞춘다
        // from:'F'(PDF 선택) — 앱은 PDF 선택창, PC 는 파일창이 PDF 만 받는다
        $('#fileUploadTmpform').prop('multiple', options.multiple)
            .attr('accept', options.from === 'F' ? 'application/pdf' : 'image/*');

        if (!$j.F.App.startUploadImage(options.tag, options.max_sheet, options.from, options.id,
            { original: !!options.original, guide: options.guide || '', pdf: !!options.pdf, pdfMaxBytes: options.pdfMaxBytes || 0 })) {
            $('#fileUploadTmpform').click();
        }
    }

    /**
     * 격자 opt-in 진입점. 지원 앱 + 전체허용이면 디바이스 사진 격자(DevicePicker)를 열고,
     * 아니면(구앱·PC, 또는 부분·거부 권한 notFull) 기존 네이티브 업로드(addPhotoHere)로 폴백한다.
     *
     * ⚠ **격자는 모바일 일지(현장사진·작업문서)에만 쓴다.** 나머지는 전부 `addPhotoHere` 다.
     *   격자는 BS 싱글톤을 파괴해서, 쓰는 화면마다 '커밋 후 되돌아오기'(hub·onCommit·BS:close)를
     *   따로 들고 있어야 한다 — 같은 일을 두 경로로 하게 되고 둘의 동작이 갈린다.
     *   실제로 서류가 그 상태였고 일지만 남기기로 정리했다(2026-09).
     *   새 화면은 고민할 것 없이 `addPhotoHere` 를 부른다.
     *
     * @param {object}  opts
     * @param {boolean} [opts.notFull] 부분·거부 권한 등으로 격자를 건너뛸지 (호출자의 _notFull 상태)
     * @param {object}  [opts.native]  폴백 시 addPhotoHere 에 넘길 옵션 {tag, context, max_sheet, id, from}
     * @param {object}  [opts.grid]    격자 DevicePicker 에 넘길 data {uploadTag, categories, onCommit, ...}
     */
    pickPhotos({ notFull = false, native = {}, grid = {} } = {}) {
        if (notFull || !$j.F.App.pickerSupported()) {
            this.addPhotoHere(native);
            return;
        }
        $j.Ui.BS.open({ target: '$j.Ui.DevicePicker', fixedHeight: true, data: grid });
    }

    /**
     * File 객체를 직접 업로드
     */
    uploadFile(file, silent = false) {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('tag', this.options.tag || 'docs');
        if (this.options.id) fd.append('id', this.options.id);

        $j.Common.Util.loadingOverlay(true);
        // 약속을 돌려준다 — 여러 장을 **고른 순서대로** 올리려면 앞 장이 끝난 뒤 다음을 던져야 한다
        return $.ajax({
            type: 'POST',
            url: `/api/upload`,
            data: fd,
            processData: false,
            contentType: false,
            success: (res) => {
                if (!res.id || silent) return;
                $j.Common.EventBus.trigger('upload:image', res);
            },
            complete: () => $j.Common.Util.loadingOverlay(false),
        });
    }

    /**
     * 여러 장을 **차례로** 올린다 (드랍존·다중선택).
     *
     * 병렬로 던지면 완료 순서가 뒤섞여 `upload:image` 가 받는 순서가 고른 순서와 달라진다 —
     * 순서가 곧 의미인 목록(불러톡 이미지 문구는 장당 톡 한 건이다)에서는 그게 곧 버그다.
     *
     * @param {FileList|File[]} files
     * @param {object} [options] {tag, context, id} — 없으면 직전 컨텍스트를 그대로 쓴다
     */
    uploadFiles(files, options) {
        if (options) this.setContext(options);
        const list = Array.from(files || []).filter(f => f && f.type && f.type.startsWith('image/'));
        if (!list.length) {
            $j.Common.Util.tsalert('warning', '이미지 파일만 업로드 가능합니다.');
            return $.Deferred().resolve().promise();
        }
        return list.reduce(
            (chain, f) => chain.then(() => this.uploadFile(f)),
            $.Deferred().resolve().promise()
        );
    }

    /**
     * 여러 장을 차례로 올린 뒤 `upload:image` 를 **배열로 한 번** 보낸다 (options.batch).
     * 장마다 따로 보내면 받는 쪽이 매번 한 장 등록으로 받아 마지막 장만 남는다 — 묶어서 쓰는 화면용.
     * 개수는 max_sheet 까지. 한 장이라도 실패하면 이벤트를 보내지 않는다.
     */
    uploadBatch(files) {
        const max = this.options.max_sheet || 1;
        if (files.length > max) {
            $j.Common.Util.tsalert('warning', `최대 ${max}장까지 올릴 수 있습니다.`);
            return $.Deferred().resolve().promise();
        }
        const done = [];
        return files.reduce(
            (chain, f) => chain.then(() => this.uploadFile(f, true).then((res) => { if (res && res.id) done.push(res); })),
            $.Deferred().resolve().promise()
        ).then(
            () => { if (done.length) $j.Common.EventBus.trigger('upload:image', done); },
            () => $j.Common.Util.tsalert('error', '업로드하지 못했습니다. 다시 시도해주세요.')
        );
    }

    /**
     * 이미지 업로드 후 이벤트 발생
     */
    uploadStart() {
        const self = this;
        if (!document.getElementById("fileUploadTmpform").value) return;

        const fd = new FormData(document.fupForm);
        fd.append('tag', this.options.tag);
        if (this.options.id) fd.append('id', this.options.id);

        $j.Common.Util.loadingOverlay(true);
        $.ajax({
            type: 'POST',
            url: `/api/upload`,
            data: fd,
            processData: false,
            contentType: false,
            success: (file) => {
                if (!file.id) return;
                // PDF 는 화면이 원래 파일명을 보여준다 — 앱 콜백처럼 name 을 실어준다
                if (self.options.from === 'F') file.name = file.name || (document.getElementById('fileUploadTmpform').files[0] || {}).name || '';

                // context에 따라 분기
                $j.Common.EventBus.trigger('upload:image', file);

                self.resetFile();
            },
            complete: () => $j.Common.Util.loadingOverlay(false),
        });
    }
}